module.exports = __webpack_public_path__ + "img/hairdreams_logo.png";